import { render, staticRenderFns } from "./StepTabs.vue?vue&type=template&id=7d6c03c7&scoped=true&"
import script from "./StepTabs.vue?vue&type=script&lang=js&"
export * from "./StepTabs.vue?vue&type=script&lang=js&"
import style0 from "./StepTabs.vue?vue&type=style&index=0&id=7d6c03c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c03c7",
  null
  
)

export default component.exports